import { render, staticRenderFns } from "./ApexDataBarChart.vue?vue&type=template&id=16aa9ba4&"
import script from "./ApexDataBarChart.vue?vue&type=script&lang=js&"
export * from "./ApexDataBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports